import React from "react";
import PartnersTable from "./PartnersTable/PartnersTable";
import { useTranslation } from "react-i18next";

function PartnersCard(props) {

    const { t } = useTranslation()

    const {partners} = props

    const partners_data = partners.partnership_data || []

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    {t("indicated_partners")}
                </div>
            </div>
            <div
                className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
            >
                {partners_data.length === 0 ?
                    t("company_partners_not_available") :
                    <PartnersTable partners_data={partners_data}/>
                }
            </div>
        </div>
        );
}


export default PartnersCard
